/* eslint-disable react/no-array-index-key */
import {
  SkeletonLine,
  SkeletonPulse,
} from 'components/theme/Skeleton/Skeleton';
import React from 'react';
import styled from 'styled-components';

export const AvailableTimeListSkeleton: React.FC = () => {
  const placeholders = [
    { id: 1, slots: 2 },
    { id: 2, slots: 2 },
    { id: 3, slots: 2 },
    { id: 4, slots: 2 },
  ];

  return (
    <>
      {placeholders.map((day) => (
        <DayRow key={day.id}>
          <DateColumn>
            <SkeletonLine style={{ width: 80, height: 16, borderRadius: 8 }} />
          </DateColumn>
          <SlotsWrap>
            {Array.from({ length: 2 }).map((_, i) => (
              <SkeletonSlot key={i} />
            ))}
          </SlotsWrap>
        </DayRow>
      ))}
    </>
  );
};

const DayRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 32px;
`;

const DateColumn = styled.div`
  min-width: 100px;
  padding-top: 10px;
`;

const SlotsWrap = styled.div`
  display: flex;
  gap: 17px;
`;

const SkeletonSlot = styled(SkeletonPulse)`
  height: 48px;
  min-width: 150px;
  flex-shrink: 0;
  flex-grow: 1;
  max-width: 180px;
`;
